<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">编辑职员</span>
    </h2>
    <breadcrumb firstName="职员管理"></breadcrumb>
    <staff-content :type="3"></staff-content>
  </div>
</template>
<script>
import breadcrumb from '@/components/global/breadcrumb';
import staffContent from './components/content.vue';
export default {
  components: {
    breadcrumb,
    staffContent
  }
};
</script>
